// extracted by mini-css-extract-plugin
module.exports = {"componentBBHero":"bb-hero__0mMvh","bb-hero-hub-home-page":"bb-hero-hub-home-page__Z21IS"};